import { _typeof } from "./index10.js";
import { toPrimitive } from "./index11.js";
function toPropertyKey(t) {
	var i = toPrimitive(t, "string");
	return "symbol" == _typeof(i) ? i : i + "";
}
export { toPropertyKey };
